import '../assets/NcFormBoxSwitch-CDDwfQx6.css';
import { defineComponent, watch } from "vue";
import { useVModel } from "@vueuse/core";
import { N as NcFormBoxItem } from "./NcFormBoxItem-DasY7_rJ.mjs";
import { N as NcIconToggleSwitch } from "./NcIconToggleSwitch-DCTeQGv5.mjs";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const __default__ = {
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  }
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  __name: "NcFormBoxSwitch",
  props: {
    label: { default: void 0 },
    description: { default: void 0 },
    disabled: { type: Boolean, default: false },
    modelValue: { type: Boolean }
  },
  emits: ["enable", "disable", "update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const model = useVModel(props, "modelValue", emit, { passive: true });
    const inputId = createElementId();
    watch(model, () => {
      if (model.value) {
        emit("enable");
      } else {
        emit("disable");
      }
    }, {
      // defineModel emits update:modelValue synchronously
      // Watching it synchronously to emit the enable/disable events together with the update:modelValue event
      flush: "sync"
    });
    return { __sfc: true, props, emit, model, inputId, NcFormBoxItem, NcIconToggleSwitch };
  }
});
const formBoxSwitch__input = "_formBoxSwitch__input_59A7r";
const style0 = {
  "material-design-icon": "_material-design-icon_AHfws",
  formBoxSwitch__input
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcFormBoxItem, { attrs: { "tag": "label", "for": _setup.inputId }, scopedSlots: _vm._u([_vm.$slots.default || _vm.label ? { key: "default", fn: function() {
    return [_vm._t("default", function() {
      return [_vm._v(" " + _vm._s(_vm.label) + " ")];
    })];
  }, proxy: true } : null, _vm.$slots.description || _vm.description ? { key: "description", fn: function() {
    return [_vm._t("description", function() {
      return [_vm._v(" " + _vm._s(_vm.description) + " ")];
    })];
  }, proxy: true } : null, { key: "icon", fn: function({ descriptionId }) {
    return [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _setup.model, expression: "model" }], class: _vm.$style.formBoxSwitch__input, attrs: { "id": _setup.inputId, "type": "checkbox", "role": "switch", "aria-describedby": descriptionId, "disabled": _vm.disabled }, domProps: { "checked": Array.isArray(_setup.model) ? _vm._i(_setup.model, null) > -1 : _setup.model }, on: { "change": function($event) {
      var $$a = _setup.model, $$el = $event.target, $$c = $$el.checked ? true : false;
      if (Array.isArray($$a)) {
        var $$v = null, $$i = _vm._i($$a, $$v);
        if ($$el.checked) {
          $$i < 0 && (_setup.model = $$a.concat([$$v]));
        } else {
          $$i > -1 && (_setup.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
        }
      } else {
        _setup.model = $$c;
      }
    } } }), _c(_setup.NcIconToggleSwitch, { attrs: { "checked": _vm.modelValue, "inline": "" } })];
  } }], null, true) });
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcFormBoxSwitch = __component__.exports;
export {
  NcFormBoxSwitch as N
};
//# sourceMappingURL=NcFormBoxSwitch-bdRBjKGq.mjs.map
